// extracted by mini-css-extract-plugin
export default {"container":"Background_container__IsHhz","blue":"Background_blue__thl3j","red":"Background_red__b7ph3"};